<template>
  <div class="bg">
    <!-- <img style="width: 100%;" src="@assets/img/at.png" alt="" srcset=""> -->
    <div class="innerBox">
      <div class="title">一、答题日期</div>
      <div class="time">{{ time }}</div>
      <div class="title">二、答题规则</div>
      <div class="time">
        （1）每日答题每人{{ count }}题，每题{{
          point
        }}分，答题类型为选择题，试题从题库中随机抽取。 <br />
        （2）每日答题不限制答题时间，答题次数限制为每人每日一次。 <br />
        （3）题目答案确定后不可更改，跳转下一题后无法返回上一题，答错也可继续答题，答题结束按分数奖励积分。<br />
      </div>
      <van-button
        style="margin-top: 0.9rem"
        type="danger"
        block
        round
        @click="todati"
        >开始答题</van-button
      >
      <!-- <img class="foot" src="@/assets/img/footer.png" alt="" srcset="" /> -->
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Button } from "vant";
import { getTodayAnswer } from "@api/answer";

Vue.use(Button);

export default {
  data() {
    return {
      time: "",
      status: 0,
      msg: "",
      count: "",
      point: 0,
    };
  },
  created() {
    this.getdate();
  },
  methods: {
    getdate() {
      getTodayAnswer()
        .then((res) => {
          this.time = res.data.time;
          this.count = res.data.count;
          this.point = res.data.point;
        })
        .catch((err) => {
          this.time = err.data.data.time;
        });
    },
    todati() {
      getTodayAnswer()
        .then((res) => {
          this.$router.push({ path: "/answer/dati" });
        })
        .catch((err) => {
          this.$dialog.error(err.msg);
        });
    },
  },
};
</script>

<style scoped>
.bg {
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-image: url("~@assets/img/bg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.innerBox {
  margin: 3%;
  background: #fdf9ee;
  border-radius: 0.2rem;
  position: absolute;
  bottom: 0;
  width: 94%;
  top: 0.2rem;
  right: 0;
  left: 0;
  padding: 0.34rem;
  color: #202020;
}
.title {
  font-size: 0.3rem;
  line-height: 0.5rem;
}
.time {
  font-size: 0.3rem;
  line-height: 0.5rem;
  padding: 0.1rem 0;
}
.foot {
  display: block;
  width: 80%;
  position: absolute;
  left: 10%;
  bottom: 0.3rem;
}
</style>
